import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Header = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  const menuRef = useRef(null);
  const policiesRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        setIsPoliciesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close policies dropdown on mobile when menu closes
  useEffect(() => {
    if (!isMenuOpen) {
      setIsPoliciesOpen(false);
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const togglePolicies = (e) => {
    e.preventDefault();
    setIsPoliciesOpen(!isPoliciesOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsPoliciesOpen(false);
  };

  return (
    <>
      <header className="navbar" ref={menuRef}>
        <div className="container nav-container">
          <div className="logo">
            <a href="/">
              <img
                src="https://app.formaxpay.com/assets/img/logo.png"
                alt="FORMAX PAY Logo"
                onError={(e) => {
                  e.target.src = "https://placehold.co/48x48?text=FP";
                }}
              />
            </a>
          </div>

          {/* Hamburger Icon for Mobile */}
          <div
            className={`hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

          {/* Navigation Links */}
          <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
            <li>
              <a href="/" onClick={closeMenu}>
                Home
              </a>
            </li>
            <li>
              <a href="/about-us" onClick={closeMenu}>
                About Us
              </a>
            </li>
            <li>
              <a href="/services" onClick={closeMenu}>
                Services
              </a>
            </li>
            {/* Policies Dropdown */}
            <li className="dropdown">
              <a href="#" className="dropdown-toggle" onClick={togglePolicies}>
                Policies <i className="fas fa-chevron-down"></i>
              </a>
              <ul className={`dropdown-menu ${isPoliciesOpen ? "show" : ""}`}>
                <li>
                  <a href="/privacy-policy" onClick={closeMenu}>
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/refund-policy" onClick={closeMenu}>
                    Refund Policy
                  </a>
                </li>
                <li>
                  <a href="/terms-and-conditions" onClick={closeMenu}>
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <a href="/contact-us" onClick={closeMenu}>
                Contact
              </a>
            </li>

            <li>
              <a
                href="https://app.formaxpay.in/"
                className="btn-outline-light"
                id="loginMock"
              >
                Sign In
              </a>
            </li>
          </ul>
        </div>
      </header>

      {/* CSS for mobile responsive menu and dropdown */}
      <style>{`
        /* Hamburger Icon Styles */
        .hamburger {
          display: none;
          flex-direction: column;
          cursor: pointer;
          gap: 5px;
          z-index: 1001;
        }
        .hamburger span {
          width: 25px;
          height: 3px;
          background-color: #1e293b;
          transition: all 0.3s ease;
          border-radius: 3px;
        }
        .hamburger.active span:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }
        .hamburger.active span:nth-child(2) {
          opacity: 0;
        }
        .hamburger.active span:nth-child(3) {
          transform: rotate(-45deg) translate(7px, -6px);
        }

        /* Desktop Nav */
        .nav-links {
          display: flex;
          gap: 28px;
          list-style: none;
          align-items: center;
          flex-wrap: wrap;
        }

        /* Dropdown styles */
        .dropdown {
          position: relative;
        }
        .dropdown-toggle {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .dropdown-toggle i {
          font-size: 0.75rem;
          transition: transform 0.2s;
        }
        .dropdown:hover .dropdown-toggle i,
        .dropdown .dropdown-toggle[aria-expanded="true"] i {
          transform: rotate(180deg);
        }
        .dropdown-menu {
          position: absolute;
          top: 100%;
          left: 0;
          background: white;
          min-width: 200px;
          border-radius: 16px;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          padding: 12px 0;
          list-style: none;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-10px);
          transition: all 0.2s;
          z-index: 1000;
          border: 1px solid #eef2ff;
        }
        .dropdown-menu.show,
        .dropdown:hover .dropdown-menu {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }
        .dropdown-menu li {
          margin: 0;
        }
        .dropdown-menu li a {
          display: block;
          padding: 10px 20px;
          color: #1e293b;
          font-size: 0.9rem;
          transition: background 0.2s;
        }
        .dropdown-menu li a:hover {
          background: #f1f5f9;
        }

        /* Mobile Responsive */
        @media (max-width: 850px) {
          .hamburger {
            display: flex;
          }
          .nav-links {
            position: fixed;
            top: 80px;
            left: -100%;
            width: 80%;
            height: calc(100vh - 80px);
            background: white;
            flex-direction: column;
            align-items: flex-start;
            padding: 30px 24px;
            gap: 24px;
            transition: left 0.3s ease;
            z-index: 1000;
            box-shadow: 5px 0 20px rgba(0, 0, 0, 0.05);
            overflow-y: auto;
          }
          .nav-links.open {
            left: 0;
          }
          .dropdown {
            width: 100%;
          }
          .dropdown-toggle {
            justify-content: space-between;
            width: 100%;
          }
          .dropdown-menu {
            position: static;
            box-shadow: none;
            padding-left: 20px;
            margin-top: 8px;
            opacity: 1;
            visibility: visible;
            transform: none;
            display: none;
            border: none;
            background: #f8fafc;
          }
          .dropdown-menu.show {
            display: block;
          }
          .dropdown-menu li a {
            padding: 10px 16px;
          }
          .nav-links li {
            width: 100%;
          }
          .btn-outline-light {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
